import React from 'react';
import { strings } from '../../../resources/strings';
import { Field, FieldType } from '../../../common-components/Field/Field';

export class FormCustomerNoteValues {
    value?: string;
}

interface IFormCustomerNoteProps {
    values?: FormCustomerNoteValues;
    change: (values: FormCustomerNoteValues) => void;
    notLabel?: boolean;
}

const FormCustomerNote: React.FC<IFormCustomerNoteProps> = ({
    values,
    change,
    notLabel
}) => {

    return (
        <>
            <Field 
                label={notLabel ? '' : strings.NewNote}
                type={FieldType.TextArea}
                value={values?.value}
                change={(value) => changeValues({...(values||{}), value: value})}
                marginTop='0px'
                autoFocus
                textAreaRows={10}
            />
        </>
    );

    function changeValues(values: FormCustomerNoteValues) {
        change({...values});
    }
}

export {FormCustomerNote};